import React from 'react'

function AddBanner() {
  return (
    <div>AddBanner</div>
  )
}

export default AddBanner